import * as React from 'react';
import { IHeaderGroupParams } from '@ag-grid-community/core';
import { style, classes } from 'typestyle';

const styles = {
  container: style({
    position: 'absolute',
    left: 10,
    right: 8,
    top: 21,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 2,
    fontSize: '.85rem',
    display: 'flex',
    alignItems: 'center',
  }),
  label: style({
    flex: '0 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  }),
  expandControl: style({
    flexShrink: 0,
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    fontSize: 14,
    cursor: 'pointer',
    color: 'black',
  }),
};

export interface CustomGroupHeaderState {
  expanded: boolean;
}

export default class CustomGroupHeader extends React.Component<IHeaderGroupParams, CustomGroupHeaderState> {
  constructor(props: IHeaderGroupParams) {
    super(props);
    this.state = {
      expanded: false,
    };

    props.columnGroup.getProvidedColumnGroup().addEventListener('expandedChanged', this.syncExpandButtons.bind(this));
  }

  componentDidMount() {
    this.syncExpandButtons();
  }

  expandOrCollapse = () => {
    const currentState = this.props.columnGroup.getProvidedColumnGroup().isExpanded();
    this.props.setExpanded(!currentState);
    this.syncExpandButtons();
  };

  syncExpandButtons = () => {
    this.setState({
      expanded: this.props.columnGroup.getProvidedColumnGroup().isExpanded(),
    });
  };

  render() {
    const providedGroup = this.props.columnGroup.getProvidedColumnGroup();
    // Use static leaf-column count so the button stays visible even when all but one
    // column has been hidden via the wrench (isExpandable() returns false in that case)
    // with 1 column, the icon just wont have an action
    const hasMultipleColumns = providedGroup.getLeafColumns().length > 1;
    const isExpandable = providedGroup.isExpandable();
    const { expanded } = this.state;
    return (
      <div className={classes('ag-header-group-cell-label', styles.container)}>
        <span className={classes(styles.label, 'customHeaderLabel')}>{this.props.displayName}</span>
        {hasMultipleColumns && (
          <i
            className={classes(
              'customExpandButton',
              expanded ? 'fas fa-angle-double-left' : 'fas fa-angle-double-right',
              styles.expandControl,
            )}
            onClick={() => isExpandable && this.expandOrCollapse()}
          />
        )}
      </div>
    );
  }
}
